import { render, staticRenderFns } from "./ExtensionAdjustment.vue?vue&type=template&id=08c36378"
import script from "./ExtensionAdjustment.vue?vue&type=script&lang=js"
export * from "./ExtensionAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports